// extracted by mini-css-extract-plugin
export default {"main":"TextBtn_main__PX2PX","text":"TextBtn_text__Lr1g7","disabledText":"TextBtn_disabledText__Wq6cb","disabled":"TextBtn_disabled__jf1+j","icon":"TextBtn_icon__YldRs"};